import { useState } from "react";
import { useForm } from "react-hook-form";
import { useBlockNoteEditor, useComponentsContext } from "@blocknote/react";

import { Input } from "components/form_components/Inputs";
import Popover from "components/ui/popover/Popover";
import UIcon from "lib/icons/untitled_ui/UIcon";

export default function CreateLinkButton() {
  const editor = useBlockNoteEditor();
  const Components = useComponentsContext();

  const [showInput, setShowInput] = useState(false);

  const { control, handleSubmit, reset } = useForm({
    defaultValues: { url: "" },
  });

  const handleLinkSubmit = handleSubmit(({ url }) => {
    if (url.trim()) {
      editor.createLink(url.trim());
    }
    setShowInput(false);
    reset();
  });

  if (!Components) {
    return <></>;
  }

  return (
    <>
      <Popover
        open={showInput}
        onOpenChange={setShowInput}
        side="bottom"
        hideArrow
        trigger={
          <Components.FormattingToolbar.Button
            label=""
            icon={<UIcon icon="link01" />}
            mainTooltip="Add link"
            onClick={() => setShowInput((show) => !show)}
          />
        }
      >
        <Input
          placeholder="Edit URL"
          prefix={<UIcon icon="link01" />}
          name="url"
          label=""
          control={control}
          allowClear
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              void handleLinkSubmit();
            }
          }}
          onBlur={handleLinkSubmit}
        />
      </Popover>
    </>
  );
}
